import React, { useContext, useEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'

import ParametersList from './ParametersList'
import { useGrantParamsOnURL } from './useGrantParamsOnURL'
interface Parameter {
    name: string
    value: any
}

const StyledContainer = styled.div`
    ${props =>
        !props.pluginHeaderNavigationDetected &&
        css`
            margin-right: 5px;
        `}

    display: flex;
    padding-left: 8px;
    .btn {
        ${props =>
            props.pluginHeaderNavigationDetected &&
            css`
                margin-top: 10px;
            `}
    }

    .btn.has-icon.has-caret.btn-default:focus {
        outline: none;
    }
    ${props =>
        props.dark &&
        css`
            background-color: #364159;

            .parameters-btn {
                border-radius: 3px;
                background-image: linear-gradient(180deg, #28334a, #1b273e);
                border: 1px solid #172033;
                color: #fff;
            }
        `}
`

export default pluginHeaderNavigationDetected => {
    const [open, setOpen] = useState(false)
    const [parameters, setParameters] = useState<Parameter[]>([])
    const { state, params, ...context } = useContext(DashboardContext)
    const contextParamsRef = useRef(params) // Params received through context, such as span, filter ...
    const paramsRef = useRef(parameters) // Params
    const updatedFromContext = useRef(false)

    const toggleParameters = () => setOpen(!open)

    let filterIsPresent = true
    if (!Array.isArray(state.currentFilterValues.asset_name_event_type)) {
        filterIsPresent = false
    }

    const asset_name_event_type: string[] = filterIsPresent ? state.currentFilterValues.asset_name_event_type : []
    if (asset_name_event_type.length !== 1) {
        console.warn('Parameter only work with one asset.')
        filterIsPresent = false
    }
    const assetName = filterIsPresent ? asset_name_event_type[0] : ''

    useEffect(() => {
        if (!assetName) return

        const controller = new AbortController()
        const signal = controller.signal
        fetch(
            `/services/plugin-asset-parameters/parameters/${context.dashboard.id}?assetName=${encodeURIComponent(
                assetName
            )}`,
            {
                signal
            }
        )
            .then(r => r.json())
            .then(data => {
                setParameters(data)
            })

        return () => controller.abort()
    }, [context.dashboard.id, assetName])

    function update(parameters) {
        fetch(
            `/services/plugin-asset-parameters/parameters/${context.dashboard.id}?assetName=${encodeURIComponent(
                assetName
            )}`,
            {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(parameters)
            }
        ).then(r => {
            if (r.ok) {
                // reload chart.
                setParameters(parameters)
                context.actions.stop()
                context.actions.start()
            } else {
                // globalNotification.error(
                //                         `${i18n('Erro ao salvar o registro de atividades')}  ${
                //                             r.statusText ? `- (${r.statusText})` : ''
                //                         }`
                //                     )
                console.error(r.status, r.statusText)
            }
        })

        toggleParameters()
    }

    function restoreDefault() {
        console.log('TODO: restore padrão')
    }

    useEffect(() => {
        contextParamsRef.current = params
    }, [JSON.stringify(params)])

    useGrantParamsOnURL(contextParamsRef, paramsRef)

    useEffect(() => {
        if (parameters.length !== 0) {
            paramsRef.current = parameters

            let parametersUpdate = parameters

            if (!updatedFromContext.current && params !== undefined && params['asset-parameters'] !== undefined) {
                let parametersUpdateArrayOfNames = parametersUpdate.map(e => e['name'])

                try {
                    JSON.parse(decodeURIComponent(decodeURIComponent(params['asset-parameters']))).map(e => {
                        if (
                            parametersUpdateArrayOfNames.indexOf(e.name) !== undefined &&
                            parametersUpdate[parametersUpdateArrayOfNames.indexOf(e.name)].value !== e.value
                        ) {
                            updatedFromContext.current = true
                            parametersUpdate[parametersUpdateArrayOfNames.indexOf(e.name)].value = e.value
                        }
                    })

                    if (updatedFromContext.current) {
                        update(parametersUpdate)
                        setParameters(parametersUpdate)
                        setOpen(false)
                    }
                } catch (err) {
                    console.error(err)
                }
            }
        }
    }, [JSON.stringify(parameters)])

    return filterIsPresent ? (
        parameters.length > 0 ? (
            <StyledContainer
                className={'dashboard-filters dropdown-container'}
                dark={context.theme === 'dark'}
                pluginHeaderNavigationDetected={pluginHeaderNavigationDetected}
            >
                <div className={'dropdown btn-group btn-group-default '}>
                    <button
                        className="btn has-icon has-caret btn-default parameters-btn"
                        onClick={() => toggleParameters()}
                    >
                        <span>
                            <i className="fa fa-cog" style={{ paddingLeft: '2px', marginRight: '8px' }} />
                            <span className={'label-bold'}>Parameters</span>
                            <i className="caret" />
                        </span>
                    </button>
                    {open && (
                        <ParametersList
                            toggle={toggleParameters}
                            parameters={parameters}
                            contextParams={params}
                            restoreDefault={restoreDefault}
                            update={update}
                            dark={context.theme === 'dark'}
                            pluginHeaderNavigationDetected={pluginHeaderNavigationDetected}
                        />
                    )}
                </div>
            </StyledContainer>
        ) : null
    ) : null
}
